"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubmitTo = exports.EIllegalParkingCaseOwner = exports.ProviderValue = exports.ProviderCode = exports.ExtractedCaseInfoField = exports.AbandonedTrolleyStore = exports.SubCategory = exports.Category = exports.CaseDisplayStatus = exports.CaseStatus = exports.SuspectedWindowType = exports.HighriseLitterType = void 0;
var HighriseLitterType;
(function (HighriseLitterType) {
    HighriseLitterType["CIGARETTE_BUTTS"] = "CIGARETTE_BUTTS";
    HighriseLitterType["DRINK_CONTAINER"] = "DRINK_CONTAINER";
    HighriseLitterType["FOOD_CONTAINER"] = "FOOD_CONTAINER";
    HighriseLitterType["FOOD_WASTE"] = "FOOD_WASTE";
    HighriseLitterType["NEWSPAPER"] = "NEWSPAPER";
    HighriseLitterType["PLASTIC_BAG"] = "PLASTIC_BAG";
    HighriseLitterType["SANITARY_PAD"] = "SANITARY_PAD";
    HighriseLitterType["TISSUE_PAPER"] = "TISSUE_PAPER";
    HighriseLitterType["URINE_FAECES"] = "URINE_FAECES";
    HighriseLitterType["WATER"] = "WATER";
    HighriseLitterType["OTHERS"] = "OTHERS";
})(HighriseLitterType || (exports.HighriseLitterType = HighriseLitterType = {}));
var SuspectedWindowType;
(function (SuspectedWindowType) {
    SuspectedWindowType["KITCHEN_WINDOW"] = "KITCHEN_WINDOW";
    SuspectedWindowType["BEDROOM_WINDOW"] = "BEDROOM_WINDOW";
    SuspectedWindowType["LIVING_ROOM_WINDOW"] = "LIVING_ROOM_WINDOW";
    SuspectedWindowType["CORRIDOR"] = "CORRIDOR";
    SuspectedWindowType["SERVICE_YARD"] = "SERVICE_YARD";
    SuspectedWindowType["OTHERS"] = "OTHERS";
})(SuspectedWindowType || (exports.SuspectedWindowType = SuspectedWindowType = {}));
var CaseStatus;
(function (CaseStatus) {
    CaseStatus["ACKNOWLEDGED"] = "ACKNOWLEDGED";
    CaseStatus["WORKING_ON_IT"] = "WORKING_ON_IT";
    CaseStatus["CLOSED"] = "CLOSED";
    CaseStatus["TIMED_OUT"] = "TIMED_OUT";
    CaseStatus["FAILED"] = "FAILED";
    CaseStatus["REDIRECTED"] = "REDIRECTED";
})(CaseStatus || (exports.CaseStatus = CaseStatus = {}));
var CaseDisplayStatus;
(function (CaseDisplayStatus) {
    CaseDisplayStatus["SUBMITTED"] = "Submitted";
    CaseDisplayStatus["IN_PROGRESS"] = "In progress";
    CaseDisplayStatus["RESOLVED"] = "Resolved";
    CaseDisplayStatus["REPLY_FROM"] = "Reply from";
})(CaseDisplayStatus || (exports.CaseDisplayStatus = CaseDisplayStatus = {}));
var Category;
(function (Category) {
    Category["SAFE_DISTANCING"] = "Safe distancing";
    Category["PESTS"] = "Pests";
    Category["ANIMAL_AND_BIRDS"] = "Animals and birds";
    Category["TAP_WATER"] = "Tap water";
    Category["PARKS_AND_GREENERY"] = "Parks and greenery";
    Category["CROWDSOURCING"] = "Crowdsourcing";
    Category["ILLEGAL_PARKING"] = "Illegal parking";
    Category["LITTER_AND_CLEANLINESS"] = "Litter and cleanliness";
    Category["ROADS_AND_PATHS"] = "Roads and footpaths";
    Category["HDB_FACILITIES"] = "HDB facilities";
    Category["DRAINS_AND_SEWERS"] = "Drains and sewers";
    Category["CONSTRUCTION_SITES"] = "Construction sites";
    Category["SHARED_BICYCLES"] = "Shared bicycles";
    Category["EVERYTHING_ELSE"] = "Everything else";
    Category["SMOKING"] = "Smoking";
})(Category || (exports.Category = Category = {}));
var SubCategory;
(function (SubCategory) {
    SubCategory["HDB_ESTATES_OR_NEIGHBOURHOOD_CENTRES"] = "HDB estates or neighbourhood centres";
    SubCategory["HAWKER_CENTRES_OR_WET_MARKETS"] = "Hawker centres or wet markets";
    SubCategory["SHOPPING_CENTRES_OR_COMMERCIAL_AREAS"] = "Shopping centres or commercial areas";
    SubCategory["COFFEE_SHOPS_OR_FOOD_ESTABLISHMENTS_IN_HDB_ESTATES"] = "Coffee shops or food establishments in HDB estates";
    SubCategory["MRT_STATIONS_OR_BUS_INTERCHANGES"] = "MRT stations or bus interchanges";
    SubCategory["PARKS_OR_ALONG_PCN"] = "Parks or along Park Connector Networks (PCN)";
    SubCategory["COMMUNITY_CLUBS"] = "Community clubs";
    SubCategory["COCKROACHES_IN_FOOD_ESTABLISHMENTS"] = "Cockroaches in food establishments";
    SubCategory["COCKROACHES_IN_COMMON_AREAS"] = "Cockroaches in common areas";
    SubCategory["MOSQUITOES"] = "Mosquitoes";
    SubCategory["RODENTS_IN_COMMON_AREAS"] = "Rodents in common areas";
    SubCategory["RODENTS_IN_FOOD_ESTABLISHMENTS"] = "Rodents in food establishments";
    SubCategory["BEES_AND_HORNETS"] = "Bees and hornets";
    SubCategory["DEAD_ANIMALS"] = "Dead animals";
    SubCategory["INJURED_ANIMALS"] = "Injured animals";
    SubCategory["BIRD_ISSUES"] = "Bird issues";
    SubCategory["CAT_ISSUES"] = "Cat issues";
    SubCategory["DOG_ISSUES"] = "Dog issues";
    SubCategory["OTHER_ANIMAL_ISSUES"] = "Other animal issues";
    SubCategory["NO_WATER"] = "No water";
    SubCategory["WATER_LEAKAGES"] = "Water leakages";
    SubCategory["WATER_PRESSURE"] = "Water pressure";
    SubCategory["WATER_QUALITY"] = "Water quality";
    SubCategory["FALLEN_TREES_OR_TREE_BRANCHES"] = "Fallen trees or tree branches";
    SubCategory["OVERGROWN_GRASS"] = "Overgrown grass";
    SubCategory["PARK_LIGHTING_MAINTENANCE"] = "Park lighting maintenance";
    SubCategory["PARK_FACILITIES_MAINTENANCE"] = "Park facilities maintenance";
    SubCategory["OTHER_PARKS_AND_GREENERY_ISSUES"] = "Other parks and greenery issues";
    SubCategory["ABANDONED_TROLLEYS"] = "Abandoned trolleys";
    SubCategory["ROADSIDE_PARKING"] = "Road";
    SubCategory["HDB_OR_URA_CAR_PARK"] = "HDB or URA car park";
    SubCategory["MOTORCYCLE_AT_VOID_DECK"] = "Motorcycle at void deck";
    SubCategory["DIRTY_PUBLIC_AREAS"] = "Dirty public areas";
    SubCategory["OVERFLOWING_LITTER_BINS"] = "Overflowing litter bins";
    SubCategory["HIGH_RISE_LITTERING"] = "High-rise littering";
    SubCategory["BULKY_WASTE_IN_HDB_COMMON_AREAS"] = "Bulky waste in HDB common areas";
    SubCategory["DAMAGED_ROAD_SIGNS"] = "Damaged road signs";
    SubCategory["FAULTY_STREETLIGHTS"] = "Faulty streetlights";
    SubCategory["COVERED_LINKWAY_MAINTENANCE"] = "Covered linkway maintenance";
    SubCategory["ROAD_MAINTENANCE"] = "Road maintenance";
    SubCategory["FOOTPATH_MAINTENANCE"] = "Footpath maintenance";
    SubCategory["LIGHTING_MAINTENANCE"] = "Lighting maintenance";
    SubCategory["COMMON_AREA_MAINTENANCE"] = "Common area maintenance";
    SubCategory["HDB_CAR_PARK_MAINTENANCE"] = "HDB car park maintenance";
    SubCategory["PLAYGROUNDS_FITNESS_FACILITIES_MAINTENANCE"] = "Playgrounds or fitness facilities maintenance";
    SubCategory["BULKY_WASTE_IN_COMMON_AREAS"] = "Bulky waste in common areas";
    SubCategory["CHOKED_DRAINS_OR_STAGNANT_WATER"] = "Choked drains or stagnant water";
    SubCategory["DAMAGED_DRAINS"] = "Damaged drains";
    SubCategory["FLOODING"] = "Flooding";
    SubCategory["SEWER_CHOKE_OR_OVERFLOW"] = "Sewer choke or overflow";
    SubCategory["SEWAGE_SMELL"] = "Sewage smell";
    SubCategory["CONSTRUCTION_NOISE"] = "Construction noise";
    SubCategory["ANYWHEEL"] = "Anywheel";
    SubCategory["HELLORIDE"] = "HelloRide";
    // Not being used anymore
    SubCategory["MOBIKE"] = "Mobike";
    SubCategory["SG_BIKE"] = "SG Bike";
    SubCategory["MOOV"] = "Moov";
    SubCategory["CORRIDOR"] = "Corridor";
    SubCategory["FOOD_PREMISES"] = "Food premises";
    SubCategory["FOOD_PREMISES_WITHIN_FOOD_STALL"] = "Food premises (within food stall)";
    SubCategory["LIFT"] = "Lift";
    SubCategory["OTHER_PROHIBITED_PLACES"] = "Other prohibited places";
    SubCategory["PARK"] = "Park";
    SubCategory["PARK_CONNECTOR"] = "Park connector";
    SubCategory["STAIRCASE"] = "Staircase";
    SubCategory["TRANSPORT_OR_ROAD_FACILITIES"] = "Transport/road facilities";
    SubCategory["VOID_DECK"] = "Void deck";
    SubCategory["PARKS_AND_PARK_CONNECTORS"] = "Parks and park connectors";
    SubCategory["OTHER_PUBLIC_AREAS"] = "Other public areas";
    SubCategory["EVERYTHING_ELSE"] = "Everything else";
    SubCategory["OTHERS"] = "Others";
})(SubCategory || (exports.SubCategory = SubCategory = {}));
var AbandonedTrolleyStore;
(function (AbandonedTrolleyStore) {
    AbandonedTrolleyStore["COLD_STORAGE"] = "Cold Storage";
    AbandonedTrolleyStore["GIANT"] = "Giant";
    AbandonedTrolleyStore["MUSTAFA"] = "Mustafa Singapore";
    AbandonedTrolleyStore["FAIRPRICE"] = "FairPrice";
    AbandonedTrolleyStore["SHENG_SIONG"] = "Sheng Siong";
    AbandonedTrolleyStore["IKEA"] = "IKEA";
})(AbandonedTrolleyStore || (exports.AbandonedTrolleyStore = AbandonedTrolleyStore = {}));
var ExtractedCaseInfoField;
(function (ExtractedCaseInfoField) {
    ExtractedCaseInfoField["ADDRESS_OF_INCIDENT"] = "Address of Incident";
    ExtractedCaseInfoField["STREET_NAME_WITH_BUILDING_NO"] = "Street Name with Building No";
    ExtractedCaseInfoField["STREET_NAME"] = "Street Name";
    ExtractedCaseInfoField["BUILDING_NAME"] = "Building Name";
    ExtractedCaseInfoField["POSTAL_CODE"] = "Postal Code";
    ExtractedCaseInfoField["DATE_OF_INCIDENT"] = "Date of Incident";
    ExtractedCaseInfoField["TIME_OF_INCIDENT"] = "Time of Incident";
    ExtractedCaseInfoField["LEVEL"] = "Level";
    ExtractedCaseInfoField["UNIT"] = "Unit";
    ExtractedCaseInfoField["DESCRIPTION_OF_OFFENDER"] = "Description of Offender";
    ExtractedCaseInfoField["TYPE_OF_LITTER_THROWN"] = "Type of Litter Thrown";
    ExtractedCaseInfoField["LAMP_POST_NUMBER"] = "Lamp Post Number";
})(ExtractedCaseInfoField || (exports.ExtractedCaseInfoField = ExtractedCaseInfoField = {}));
var ProviderCode;
(function (ProviderCode) {
    ProviderCode["AHTC"] = "AHTC";
    ProviderCode["AMKTC"] = "AMKTC";
    ProviderCode["BTPTC"] = "BTPTC";
    ProviderCode["CCKTC"] = "CCKTC";
    ProviderCode["ECFSTC"] = "ECFSTC";
    ProviderCode["ECTC"] = "ECTC";
    ProviderCode["HBPTC"] = "HBPTC";
    ProviderCode["JBTC"] = "JBTC";
    ProviderCode["JRTC"] = "JRTC";
    ProviderCode["JRCTC"] = "JRCTC";
    ProviderCode["MPTC"] = "MPTC";
    ProviderCode["MYTTC"] = "MYTTC";
    ProviderCode["NSTC"] = "NSTC";
    ProviderCode["PRPGTC"] = "PRPGTC";
    ProviderCode["SBTC"] = "SBTC";
    ProviderCode["TTC"] = "TTC";
    ProviderCode["TPTC"] = "TPTC";
    ProviderCode["WCTC"] = "WCTC";
    ProviderCode["AVA"] = "AVA";
    ProviderCode["BCA"] = "BCA";
    ProviderCode["HDB"] = "HDB";
    ProviderCode["LTA"] = "LTA";
    ProviderCode["NEA"] = "NEA";
    ProviderCode["NPARKS"] = "NPARKS";
    ProviderCode["PA"] = "PA";
    ProviderCode["PUB"] = "PUB";
    ProviderCode["SLA"] = "SLA";
    ProviderCode["SPF"] = "SPF";
    ProviderCode["URA"] = "URA";
    ProviderCode["SKTC"] = "SKTC";
    ProviderCode["SFA"] = "SFA";
    ProviderCode["COA"] = "COA";
    ProviderCode["TPIOP"] = "TPIOP";
    ProviderCode["AGC"] = "AGC";
    ProviderCode["AGO"] = "AGO";
    ProviderCode["ASTAR"] = "ASTAR";
    ProviderCode["BOA"] = "BOA";
    ProviderCode["CAAS"] = "CAAS";
    ProviderCode["CAB"] = "CAB";
    ProviderCode["CCCS"] = "CCCS";
    ProviderCode["CEA"] = "CEA";
    ProviderCode["CNB"] = "CNB";
    ProviderCode["COLDSTORAGE"] = "COLDSTORAGE";
    ProviderCode["CPFB"] = "CPFB";
    ProviderCode["CPIB"] = "CPIB";
    ProviderCode["CRA"] = "CRA";
    ProviderCode["GRA"] = "GRA";
    ProviderCode["CSC"] = "CSC";
    ProviderCode["CUSTOMS"] = "CUSTOMS";
    ProviderCode["DSTA"] = "DSTA";
    ProviderCode["EDB"] = "EDB";
    ProviderCode["ELD"] = "ELD";
    ProviderCode["EMA"] = "EMA";
    ProviderCode["ESG"] = "ESG";
    ProviderCode["GIANT"] = "GIANT";
    ProviderCode["GovTech"] = "GovTech";
    ProviderCode["HEB"] = "HEB";
    ProviderCode["HLB"] = "HLB";
    ProviderCode["HPB"] = "HPB";
    ProviderCode["HSA"] = "HSA";
    ProviderCode["IAC"] = "IAC";
    ProviderCode["ICA"] = "ICA";
    ProviderCode["IMDA"] = "IMDA";
    ProviderCode["IPOS"] = "IPOS";
    ProviderCode["IRAS"] = "IRAS";
    ProviderCode["ISEAS"] = "ISEAS";
    ProviderCode["ISTANA"] = "ISTANA";
    ProviderCode["ITE"] = "ITE";
    ProviderCode["JTC"] = "JTC";
    ProviderCode["MAS"] = "MAS";
    ProviderCode["MCCY"] = "MCCY";
    ProviderCode["MCI"] = "MCI";
    ProviderCode["MFA"] = "MFA";
    ProviderCode["MHA"] = "MHA";
    ProviderCode["MINDEF"] = "MINDEF";
    ProviderCode["MINLAW"] = "MINLAW";
    ProviderCode["MND"] = "MND";
    ProviderCode["MOE"] = "MOE";
    ProviderCode["MOF"] = "MOF";
    ProviderCode["MOH"] = "MOH";
    ProviderCode["MOM"] = "MOM";
    ProviderCode["MOT"] = "MOT";
    ProviderCode["MPA"] = "MPA";
    ProviderCode["MSE"] = "MSE";
    ProviderCode["MSF"] = "MSF";
    ProviderCode["MTI"] = "MTI";
    ProviderCode["MUIS"] = "MUIS";
    ProviderCode["MUSTAFA"] = "MUSTAFA";
    ProviderCode["NAC"] = "NAC";
    ProviderCode["NCSS"] = "NCSS";
    ProviderCode["NHB"] = "NHB";
    ProviderCode["NLB"] = "NLB";
    ProviderCode["NP"] = "NP";
    ProviderCode["NTUCFAIRPRICE"] = "NTUCFAIRPRICE";
    ProviderCode["NYP"] = "NYP";
    ProviderCode["PAPRISM"] = "PAPRISM";
    ProviderCode["PARL"] = "PARL";
    ProviderCode["PDPC"] = "PDPC";
    ProviderCode["PEB"] = "PEB";
    ProviderCode["PMO"] = "PMO";
    ProviderCode["PSC"] = "PSC";
    ProviderCode["PSD"] = "PSD";
    ProviderCode["PTC"] = "PTC";
    ProviderCode["RP"] = "RP";
    ProviderCode["SAC"] = "SAC";
    ProviderCode["SCB"] = "SCB";
    ProviderCode["SCDF"] = "SCDF";
    ProviderCode["SCORE"] = "SCORE";
    ProviderCode["SDC"] = "SDC";
    ProviderCode["SEAB"] = "SEAB";
    ProviderCode["SENTOSA"] = "SENTOSA";
    ProviderCode["SHENGSIONG"] = "SHENGSIONG";
    ProviderCode["SLF"] = "SLF";
    ProviderCode["SMC"] = "SMC";
    ProviderCode["SNB"] = "SNB";
    ProviderCode["SP"] = "SP";
    ProviderCode["SPC"] = "SPC";
    ProviderCode["SPORTSG"] = "SPORTSG";
    ProviderCode["SPS"] = "SPS";
    ProviderCode["SSG"] = "SSG";
    ProviderCode["STATECOURTS"] = "STATECOURTS";
    ProviderCode["STB"] = "STB";
    ProviderCode["SUPCOURT"] = "SUPCOURT";
    ProviderCode["TCMPB"] = "TCMPB";
    ProviderCode["TOTEBOARD"] = "TOTEBOARD";
    ProviderCode["TP"] = "TP";
    ProviderCode["WSG"] = "WSG";
    ProviderCode["CRU"] = "CRU";
    ProviderCode["HTX"] = "HTX";
    ProviderCode["MDDI"] = "MDDI";
})(ProviderCode || (exports.ProviderCode = ProviderCode = {}));
var ProviderValue;
(function (ProviderValue) {
    ProviderValue["TOWN_COUNCIL"] = "town council";
    ProviderValue["AGENCY"] = "agency";
    ProviderValue["OPERATOR"] = "operator";
})(ProviderValue || (exports.ProviderValue = ProviderValue = {}));
var EIllegalParkingCaseOwner;
(function (EIllegalParkingCaseOwner) {
    EIllegalParkingCaseOwner["OSSG"] = "OSSG";
    EIllegalParkingCaseOwner["HDB"] = "HDB";
    EIllegalParkingCaseOwner["LTA"] = "LTA";
    EIllegalParkingCaseOwner["URA"] = "URA";
})(EIllegalParkingCaseOwner || (exports.EIllegalParkingCaseOwner = EIllegalParkingCaseOwner = {}));
var ESubmitTo;
(function (ESubmitTo) {
    ESubmitTo["OSSG"] = "OSSG";
    ESubmitTo["HDB"] = "HDB";
    ESubmitTo["CERTIS"] = "Certis";
})(ESubmitTo || (exports.ESubmitTo = ESubmitTo = {}));
//# sourceMappingURL=enum.js.map